import { Component, OnInit } from '@angular/core';
import { Title }             from '@angular/platform-browser';
import { Utility }           from './../Common/Services/utility';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {
  public constructor(private titleService: Title) { }

  ngOnInit() {
    this.setTitle("Red Hat Exam Scheduler");
  }

  public setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/app.component.ts